<template>
    <footer class="menu">
        <hr/>
        <router-link to="/dummy/episode/edit-meta">Breyta upplýsingum þáttar</router-link>
        <router-link to="/dummy/topic/add">Búa til umræðuefni</router-link>
        <router-link to="/">Forsíða</router-link>
    </footer>
</template>

<script>
    export default {
        name: 'AdminFooter'
    }
</script>

<style scoped>

    footer.menu{
        font-size: 0.8em;
    }

    footer.menu hr{
        font-size: 0.8em;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    footer.menu a{
        border: 1px solid white;
        border-radius: 5px;
        padding: 5px 10px;
        margin: 10px 15px;
        display: block;
        width: 125px;
    }

</style>


// WEBPACK FOOTER //
// src/components/admin/AdminFooter.vue